// Copyright (c) 2025 Audere, All Rights Reserved

import {
  InputBase,
  type InputBaseProps,
  type SxProps,
  type Theme,
  alpha,
  styled,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: 1000,
  backgroundColor: alpha(theme.palette.common.black, 0.04),
  "&:hover": { backgroundColor: alpha(theme.palette.common.black, 0.08) },
  height: "56px",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  height: "100%",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
  },
}));

const SearchInput = (props: {
  sx?: SxProps<Theme>;
  inputProps?: InputBaseProps;
}) => {
  const { sx, inputProps } = props;
  return (
    <Search sx={sx}>
      <SearchIconWrapper>
        <SearchIcon color="primary" />
      </SearchIconWrapper>
      <StyledInputBase
        inputProps={{
          "aria-label": "search",
        }}
        {...inputProps}
      />
    </Search>
  );
};

export default SearchInput;
